<template>
  <el-container class="container">
    <el-header height="60px">
      <app-header></app-header>
    </el-header>
    <el-container class="innerContainer">
      <el-aside class="sidebar-container" width="100px;">
        <sidebar :side-bar-list="sidebarData" @select="selectSideBar"/>
      </el-aside>
      <el-main>
        <tags-view/>
        <section class="app-main">
          <transition name="fade-transform" mode="out-in">
            <keep-alive :include="include">
              <router-view :key="key" class="routerView"></router-view>
            </keep-alive>
          </transition>
        </section>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { Sidebar, TagsView, Header } from '@/components';
import {
  findNode,
} from '@/utils';
// import { initSocket, disconnectSocket } from '@/socket';

export default {
  data() {
    return {
      sideBarList: [{
        icon: require('@/assets/dingdan.png'),
        activeIcon: require('@/assets/dingdan.png'),
        navItem: '订单',
        path: '/incoming-order',
        children: [{
          path: '/incoming-order/list',
          navItem: '订单记录',
        }, {
          path: '/incoming-order/create',
          navItem: '创建订单',
        }],
      },{
        icon: require('@/assets/icon_product.png'),
        activeIcon: require('@/assets/icon_product.png'),
        path: '/product-manage/list',
        navItem: '产品',
      }, {
        icon: require('@/assets/shouliao.png'),
        activeIcon: require('@/assets/shouliao.png'),
        path: '/income-storage/list',
        navItem: '来料',
      }, {
        icon: require('@/assets/product.png'),
        activeIcon: require('@/assets/product.png'),
        path: '/product-storage/list',
        navItem: '成品',
      }, {
        icon: require('@/assets/fahuo.png'),
        activeIcon: require('@/assets/fahuo.png'),
        path: '/deliver-goods',
        navItem: '发货',
        children: [{
          path: '/delivery-order/index',
          navItem: '发货建单',
        }, {
          path: '/delivery-operation/index',
          navItem: '发货操作',
        }, {
          path: '/scan-return-ticket/index',
          navItem: '扫描回签单',
        }, {
          path: '/deliver-history/index',
          navItem: '历史发货',
        }],
      },{
        icon: require('@/assets/daifahuo.png'),
        activeIcon: require('@/assets/daifahuo.png'),
        path: '/tpProdOrder-manage',
        navItem: '代发',
        children: [{
          path: '/tpProd-order/index',
          navItem: '代发建单',
        }, {
          path: '/tpProd-operation/index',
          navItem: '代发操作',
        }, {
          path: '/tpProd-scan-return-ticket/index',
          navItem: '代发扫描回签单',
        }, {
          path: '/tpProd-history/index',
          navItem: '代发历史',
        }],
      }, {
        icon: require('@/assets/jindu.png'),
        activeIcon: require('@/assets/jindu.png'),
        path: '/test-progress/list',
        navItem: '进度',
      }, {
        icon: require('@/assets/icon_label.png'),
        activeIcon: require('@/assets/icon_label.png'),
        path: '/all-label-manage',
        navItem: '标签',
        children: [{
          path: '/label-manage',
          navItem: '生产标签打印',
        }, {
          path: '/factory-label-history/list',
          navItem: '历史发货标签',
        }, {
          path: '/factory-label-template/list',
          navItem: '发货标签模板',
        }],
      }, {
        icon: require('@/assets/icon_customers.png'),
        activeIcon: require('@/assets/icon_customers.png'),
        path: '/customers-page/list',
        navItem: '客户',
      }, {
        icon: require('@/assets/device.png'),
        activeIcon: require('@/assets/device.png'),
        path: '/asset-management',
        navItem: '资产',
        children: [{
          path: '/asset-management/device',
          navItem: '设备管理',
        }, {
          path: '/asset-management/deviceDelivery',
          navItem: '设备发货',
        }],
      }],
    };
  },
  components: {
    Sidebar,
    TagsView,
    'app-header': Header,
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
    include() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
    sidebarData() {
      const {
        userInfo,
      } = this;
      let menu = [];
      if (userInfo && userInfo.roles && userInfo.roles[0] && userInfo.roles[0].name === 'printer') {
        menu = [{
          icon: require('@/assets/icon_label.png'),
          activeIcon: require('@/assets/icon_label.png'),
          path: '/all-label-manage',
          navItem: '标签',
          children: [{
            path: '/factory-label-history/list',
            navItem: '历史发货标签',
          }, {
            path: '/factory-label-template/list',
            navItem: '发货标签模板',
          }],
        }];
      } else {
        menu = this.sideBarList;
      }
      // const routePath = this.$route.path;
      // if (routePath !== '/' && routePath !== '/homepage') {
      //   const find = findNode(menu, (item) => {
      //     return item.path === routePath;
      //   });
      //   if (!find) {
      //     const firstMenu = menu[0];
      //     if (firstMenu.children) {
      //       this.$router.replace(firstMenu.children[0].path);
      //     } else {
      //       this.$router.replace(firstMenu.path);
      //     }
      //   }
      // }
      return menu;
    },
  },
  methods: {
    selectSideBar(index, indexPath) {
      if (index === '/label-manage') {
        const { href } = this.$router.resolve({
          path: `/label-manage`,
          query: {},
        });
        window.open(href, '_blank');
      } else {
        try {
          this.$router.push(index);
        } catch (e) {
          console.error(e);
        }
      }
    }
  },
  created() {
    // initSocket();
  },
  mounted() {
    // window.onbeforeunload = () => {
    //   disconnectSocket();
    // };
  },
  destroyed() {
    // disconnectSocket();
  },
};
</script>

<style lang="less" scoped>
  .container {
    height: 100%;
  }
  .el-header {
    background-color: white;
    line-height: 60px;
  }
  .innerContainer {
    height: calc(100% - 60px);
  }
  .el-main {
    padding: 0;
    height: 100%;
  }
  .app-main {
    height: calc(100% - 36px);
  }
</style>
